var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticClass:"slider"},[_vm._t("default"),(_vm.dots)?_c('div',{ref:"dots",staticClass:"dots"},_vm._l((_vm.size),function(n){return _c('div',{staticClass:"dot",class:{active: n === _vm.page + 1}})}),0):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }